import { render, staticRenderFns } from "./ZweiFaktorSchritt.vue?vue&type=template&id=c495d7f4&scoped=true"
import script from "./ZweiFaktorSchritt.vue?vue&type=script&lang=js"
export * from "./ZweiFaktorSchritt.vue?vue&type=script&lang=js"
import style0 from "./ZweiFaktorSchritt.vue?vue&type=style&index=0&id=c495d7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c495d7f4",
  null
  
)

export default component.exports